import React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import FileUploader from 'components/FileUploader/FileUploader';
import { url } from 'constants/api.constants';
import { getSclaAppPromptsPath, getSclaAppRecPath } from 'utils/navigation';
import SclaStepCard from '../components/steps/SclaStepCard';
import useSclaSectionPath from '../hooks/useSclaSectionPath';
import useUpdateSclaAppTranscripts from '../hooks/useUpdateSclaAppTranscripts';
import { SclaApplicationOutletContext } from './SclaAppLayout';

export default function SclaApplicationTranscripts() {
  const { application, setApplication, yearClosed } =
    useOutletContext<SclaApplicationOutletContext>();
  const { files, isLoading, onRemove, onError, onSuccess, setIsLoading } =
    useUpdateSclaAppTranscripts(application, setApplication);
  const sectionPath = useSclaSectionPath();
  const navigate = useNavigate();

  return (
    <SclaStepCard
      title="Transcripts"
      intro="Upload your most recent report card or unofficial transcript."
      backTo={sectionPath(getSclaAppPromptsPath())}
      onContinue={async () => {
        navigate(sectionPath(getSclaAppRecPath()));
        return true;
      }}
      continueLabel="Save and continue →"
      readOnly={yearClosed}
    >
      <div id="scla-transcripts">
      <FileUploader
        setIsLoading={setIsLoading}
        files={files}
        isLoading={isLoading}
        onRemove={onRemove}
        onError={onError}
        onSuccess={onSuccess}
        readOnly={yearClosed}
        documentsOnly
        inputLabel="Upload transcript"
        hint="PDF, JPG or PNG up to 40 MB."
        url={`${url.API_URL}/scla/application/transcripts/${application._id}`}
      />
      </div>
    </SclaStepCard>
  );
}
